import {CommentUpdate} from "@share/comments/type/CommentUpdatedMessage";
import {Comment} from "@api/models/comments/Comment";
import {UserProfileShortInterface} from "@api/models/interfaces/UserProfileInterface";

export const parseCommentUpdates = (commentUpdates: CommentUpdate[]) => {
    return commentUpdates.reduce<{ profiles: UserProfileShortInterface[]; comments: Comment[] }>(
        (accumulator, item) => {
            const {profile, ...comment} = item;
            profile && accumulator.profiles.push({...profile, userId: comment.userId});
            accumulator.comments.push(new Comment(comment));
            return accumulator;
        },
        { profiles: [], comments: [] }
    );
}
